<template lang="pug">
  ods-dropdown(
    :hide-on-click='false'
    icon='setting'
    @visible-change='handleVisibleChange')
    ods-dropdown-menu.popover-columns.desplegable(slot='dropdown')
      h3.titulosetting {{ $t('msg_generics.filter_table_menu') }}
      ods-dropdown-item(
        v-for='(column, index) in columns',
        :key='index')
        ods-checkbox(
          @input='handlerShowColumns(column)',
          v-model='column.show')
          | {{ column.text }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'b2b-table-menu-pending-task',
  props: [],
  data () {
    return {
      columns: [],
      column: {}
    }
  },
  computed: {
    ...mapGetters([
      // Columnas Tabla Recepciones emitidas
      'isShowBuyerPendingTask',
      'isShowBuyerCentersPendingTask',
      'isShowSellerPendingTask',
      'isShowNumPendingTask',
      'isShowDateIssuePendingTask',
      'isShowDateCreationPendingTask',
      'isShowImportPendingTask',
      'isShowCurrencyPendingTask',
      'isShowStatusPendingTask',
      'isShowReceptionMethodPendingTask',
      'isShowIsPendingTask',
      'isShowStatusInternalPendingTask',
      'isShowRegisterNumberPendingTask',
      'optionsFilterService'
    ])
  },

  methods: {
    ...mapActions([
      'isShowBuyerPendingTaskAction',
      'isShowBuyerCentersPendingTaskAction',
      'isShowSellerPendingTaskAction',
      'isShowNumPendingTaskAction',
      'isShowDateIssuePendingTaskAction',
      'isShowDateCreationPendingTaskAction',
      'isShowImportPendingTaskAction',
      'isShowCurrencyPendingTaskAction',
      'isShowStatusPendingTaskAction',
      'isShowReceptionMethodPendingTaskAction',
      'isShowIsPendingTaskAction',
      'isShowStatusInternalPendingTaskAction',
      'isShowRegisterNumberPendingTaskAction'
    ]),

    handlerShowColumns (col) {
      console.log('handlerShowColumns en B2bTable: ', col)
      const column = col.value
      let isShow
      switch (column) {
        case 'comprador':
          isShow = !this.isShowBuyerPendingTask
          this.isShowBuyerPendingTaskAction(isShow)
          break
        case 'compradorcentros':
          isShow = !this.isShowBuyerCentersPendingTask
          this.isShowBuyerCentersPendingTaskAction(isShow)
          break
        case 'vendedor':
          isShow = !this.isShowSellerPendingTask
          this.isShowSellerPendingTaskAction(isShow)
          break
        case 'factura':
          isShow = !this.isShowNumPendingTask
          this.isShowNumPendingTaskAction(isShow)
          break
        case 'fechaemi':
          isShow = !this.isShowDateIssuePendingTask
          this.isShowDateIssuePendingTaskAction(isShow)
          break
        case 'fechareg':
          isShow = !this.isShowDateCreationPendingTask
          this.isShowDateCreationPendingTaskAction(isShow)
          break
        case 'importe':
          isShow = !this.isShowImportPendingTask
          this.isShowImportPendingTaskAction(isShow)
          break
        case 'moneda':
          isShow = !this.isShowCurrencyPendingTask
          this.isShowCurrencyPendingTaskAction(isShow)
          break
        case 'estado':
          isShow = !this.isShowStatusPendingTask
          this.isShowStatusPendingTaskAction(isShow)
          break
        case 'metodorec':
          isShow = !this.isShowReceptionMethodPendingTask
          this.isShowReceptionMethodPendingTaskAction(isShow)
          break
        case 'tareapendiente':
          isShow = !this.isShowIsPendingTask
          this.isShowIsPendingTaskAction(isShow)
          break
        case 'estadointerno':
          isShow = !this.isShowStatusInternalPendingTask
          this.isShowStatusInternalPendingTaskAction(isShow)
          break
        case 'num_registro':
          isShow = !this.isShowRegisterNumberPendingTask
          this.isShowRegisterNumberPendingTaskAction(isShow)
          break
        default:
          break
      }
    },
    handleVisibleChange () {
      this.chargeFilters()
    },
    chargeFilters () {
      this.columns = [
        {
          text: this.$t('pendingtask.pendingtask_entity_table.buyer'), value: 'comprador', show: this.isShowBuyerPendingTask
        }, {
          text: this.$t('pendingtask.pendingtask_entity_table.buyer_centres'), value: 'compradorcentros', show: this.isShowBuyerCentersPendingTask
        }, {
          text: this.$t('pendingtask.pendingtask_entity_table.seller'), value: 'vendedor', show: this.isShowSellerPendingTask
        }, {
          text: this.$t('pendingtask.pendingtask_entity_table.num_pendingtask'), value: 'factura', show: this.isShowNumPendingTask
        }, {
          text: this.$t('pendingtask.pendingtask_entity_table.issue_date'), value: 'fechaemi', show: this.isShowDateIssuePendingTask
        }, {
          text: this.$t('pendingtask.pendingtask_entity_table.creation_date'), value: 'fechareg', show: this.isShowDateCreationPendingTask
        }, {
          text: this.$t('pendingtask.pendingtask_entity_table.import'), value: 'importe', show: this.isShowImportPendingTask
        }, {
          text: this.$t('pendingtask.pendingtask_entity_table.divisa'), value: 'moneda', show: this.isShowCurrencyPendingTask
        }, {
          text: this.$t('pendingtask.pendingtask_entity_table.status'), value: 'estado', show: this.isShowStatusPendingTask
        }, {
          text: this.$t('pendingtask.pendingtask_entity_table.reception_method'), value: 'metodorec', show: this.isShowReceptionMethodPendingTask
        }, {
          text: this.$t('pendingtask.pendingtask_entity_table.pendingtask'), value: 'tareapendiente', show: this.isShowIsPendingTask
        }, {
          text: this.$t('pendingtask.pendingtask_entity_table.internal_status'), value: 'estadointerno', show: this.isShowStatusInternalPendingTask
        }, {
          text: this.$t('pendingtask.pendingtask_entity_table.register_number'), value: 'num_registro', show: this.isShowRegisterNumberPendingTask
        }
      ]
    }
  },
  created () {
    this.chargeFilters()
  }
}
</script>

<style lang="scss" scoped>
.desplegable {
    top: 180px !important
}
.titulosetting {
      padding: 10px;
}
</style>
